import { useOutletContext } from 'react-router-dom';

import CrosstabBuilder from './CrosstabBuilder';
import SidebarNavAnalytics from './SidebarNavAnalytics';
import { SurveyLaunchedContext } from './SurveyLaunchedPage';
import SurveyWithSidebar from 'components/layout/SurveyWithSidebar';
import ExportPageNavigation from './ExportPageNavigation';

export const Crosstab = () => {
  const { questions, survey, surveyId, waves } =
    useOutletContext<SurveyLaunchedContext>();

  return (
    <SurveyWithSidebar sidebarNav={<SidebarNavAnalytics surveyId={surveyId} />}>
      <ExportPageNavigation currentPage="crosstab" surveyId={surveyId} />
      {survey && (
        <CrosstabBuilder questions={questions} survey={survey} waves={waves} />
      )}
    </SurveyWithSidebar>
  );
};
